// extracted by mini-css-extract-plugin
export default {"info-box":"InfoBox_info-box__yJRvM","card":"InfoBox_card__3518B"};